import { render, staticRenderFns } from "./MassSelectDeleteConfirmModal.vue?vue&type=template&id=0c2800fc"
import script from "./MassSelectDeleteConfirmModal.vue?vue&type=script&lang=ts"
export * from "./MassSelectDeleteConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports